module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books edition 2016")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2015 by Spellman Enterprises, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Lutz, Lisa."), _c('br'), _vm._v("\nHow to start a fire / Lisa Lutz.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("pages ; cm")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-544-41163-0 (hardcover)—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-544-40964-4 (ebook)—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-544-70518-0 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("1. Female friendship—Fiction. 2. Life change events—Fiction. 3. Chick lit. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PS")]), _vm._v("3612."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("U")]), _vm._v("897 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("H")]), _vm._v("69 2015")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("813'.6—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("2014033603")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Cover design by Christopher Moisan")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Cover illustration © Maria Cecilia Azzali")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Author photograph © David Hayward")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Excerpt from “Highway 61 Revisited” by Bob Dylan. Copyright © 1965 by Warner Bros. Inc.; renewed 1993 by Special Rider Music. All rights reserved. International copyright secured. Reprinted by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Excerpt from “The New Music” by Donald Barthelme. Copyright © 1981, 1982 by Donald Barthelme, currently collected in "), _c('em', [_vm._v("Sixty Stories")]), _vm._v(", used by permission of The Wylie Agency, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("“Earth People,” Words and Music by Daniel Nakamura and Keith Thornton © 1997 Oct Music (ASCAP)/Reservoir Media Music (ASCAP). Administered by Reservoir Media Management, Inc. All Rights Reserved. Used by Permission of Alfred Music.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("v4.0220")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0